import React, { useEffect, useMemo, useState } from "react";

import { getUserStatTableColumns } from "../../helpers/tableColumns";
import {
  CurrencyDollar,
  HourglassSplit,
  PersonCircle,
  Laptop,
  Link45deg,
  BoxArrowUpRight,
} from "react-bootstrap-icons";
import { Col, Row, Table } from "react-bootstrap";
import DataTable from "../common/data-table/DataTable";
import { getJobTitle } from "../../Util/jobUtil";
import { uniqueId } from "lodash";
import { Link } from "react-router-dom";

const ViewJobDetails = ({ jobs }) => {
  return (
    <div className="m-1 p-1 bg-white">
      <Table striped className="m-0">
        <thead>
          <tr>
            <th className="smallFont p-1 text-left">Job Description</th>{" "}
            <th className="smallFont p-1">Hour</th>{" "}
            <th className="smallFont p-1">Cost</th>
          </tr>
        </thead>
        <tbody>
          {jobs?.map((job) => {
            return (
              <tr key={job?.job?._id}>
                {" "}
                <Link
                  className="smallFont p-1 fw-bold"
                  to={`/job/${job?.job?._id}`}
                  target="_blank"
                >
                  {getJobTitle(job?.job)} <BoxArrowUpRight className="ml-1" />
                </Link>
                <td align="center" className="smallFont p-1">
                  {job?.hours || 0}
                </td>{" "}
                <td align="center" className="smallFont p-1">
                  $ {job?.cost || 0}
                </td>{" "}
              </tr>
            );
          })}{" "}
        </tbody>
      </Table>
    </div>
  );
};

const ViewStatByUser = ({ data = [], fetchingUserStats }) => {
  const [stats, setStats] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);

  const tableColumns = useMemo(() => getUserStatTableColumns(), []);

  const totalJobs = useMemo(() => {
    const uniqueJobs = [
      ...new Set(
        stats
          .flatMap((userStat) => userStat.jobs)
          .map((jobStat) => jobStat?.job?._id)
          .filter((jobId) => jobId)
      ),
    ];
    return uniqueJobs.length;
  }, [stats]);

  const userStatFields = useMemo(
    () => [
      {
        label: "Users",
        key: "userCount",
        Icon: PersonCircle,
        color: "#BC70A4",
        value: stats?.length,
      },
      {
        label: "Jobs",
        key: "jobCount",
        Icon: Laptop,
        color: "#BC70A4",
        value: totalJobs,
      },
      {
        label: "Hours worked",
        key: "hour",
        Icon: HourglassSplit,
        color: "#ff8787",
        value: stats
          ?.flatMap((d) => d.jobs)
          ?.reduce((a, v) => a + Number(v?.hours), 0)
          ?.toFixed(2),
      },
      {
        label: "Cost",
        key: "cost",
        Icon: CurrencyDollar,
        color: "#51cf66",
        value: stats
          ?.flatMap((d) => d.jobs)
          ?.reduce((a, v) => a + Number(v?.cost), 0)
          ?.toFixed(2),
      },
    ],
    [stats]
  );

  const onRowClick = (row) => {
    setExpandedRow(expandedRow === row?._id ? null : row?._id);
  };

  useEffect(() => {
    setStats(data?.map((d) => ({ ...d, _id: uniqueId() })));
  }, [data]);

  return (
    <div className="mb-2 px-2 pt-1">
      {" "}
      <Row>
        <Col md={12} lg={12}>
          <h6 className="smallFont fw-bold">Summary</h6>
          <div className="d-flex gap-3">
            {userStatFields?.map(({ Icon, label, key, color, value }) => (
              <div
                key={key}
                style={{ height: 80, width: 200 }}
                className="d-flex px-2 gap-2 align-items-center rounded border hover"
              >
                {" "}
                <Icon style={{ color }} size={30} />
                <div className="flex-grow-1">
                  {" "}
                  <h6 className={`mb-0`} style={{ fontWeight: 700 }}>
                    {value}
                  </h6>
                  <h6 className="mb-0 small-text text-secondary"> {label}</h6>
                </div>
              </div>
            ))}
          </div>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={12}>
          <h6 className="smallFont fw-bold">User Details</h6>
          <DataTable
            rowKey="_id"
            data={stats}
            onRowClick={onRowClick}
            loadingFirstPageData={fetchingUserStats}
            expandedRowKeys={expandedRow ? [expandedRow] : []}
            renderExpandedRow={(data) => <ViewJobDetails jobs={data?.jobs} />}
            columns={tableColumns}
            allowFilter={false}
            allowSort={false}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ViewStatByUser;
